export default __webpack_public_path__ + "static/media/full-cev-dark.d1c8871e.png";